<template>
	<v-app>
		<default-bar />

		<default-drawer />

		<default-view />

		<default-footer />
	</v-app>
</template>

<script>
	import { call } from 'vuex-pathify'

	export default {
		name: 'DefaultLayout',

		components: {
			DefaultBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./AppBar'
			),
			DefaultDrawer: () => import(
				/* webpackChunkName: "default-drawer" */
				'./Drawer'
			),
			DefaultFooter: () => import(
				/* webpackChunkName: "default-footer" */
				'./Footer'
			),
			DefaultView: () => import(
				/* webpackChunkName: "default-view" */
				'./View'
			),
		},
		mounted() {
			this.prepareData()
		},
		methods: {
			...call('agentAppSettings/*'),
			prepareData() {
				this.fetch({ force: true })
			}
		}
	}
</script>
